import { Pipe, PipeTransform } from '@angular/core';

/**
 * upper case the first letter of the given string.
 *
 * Examples:
 *  "hiroki chalfant" => "Hiroki chalfant"
 *  " - the barber of seville" => " - The barber of seville"
 *  " + new registration " => " + New registration"
 */
@Pipe({
  name: 'ucfirst',
  pure: true,
  standalone: false
})
export class WlUpperCaseFirstLetterPipe implements PipeTransform {
  /**
   * upper case the first letter of the given string
   * @param value
   */
  transform(value: string): string {
    if (!value) return value;

    // find first letter
    const firstLetterIndex: number = value.search(/[a-z]/i);

    // no letters
    if (firstLetterIndex < 0) return value;

    // rebuild string and use uppercase character for the first letter found
    return value.substr(0, firstLetterIndex) + value[firstLetterIndex].toLocaleUpperCase() + value.substr(firstLetterIndex + 1);
  }
}
